<template>
  <div class="flex flex-wrap -mx-7 md:-mx-3 pb-8">
    <div
      class="grow flex px-3 mb-2"
      :class="{ 'md:w-5/12': latestreviews?.length }"
    >
      <div class="bg-blue-750 product-reviews__overview-block text-white flex flex-col justify-center items-center grow py-14 px-4 text-center md:rounded-lg">
        <div class="product-reviews__block_review_rating flex justify-center items-end mb-2 drop-shadow-light z-[3]">
          <h4
            class="mb-0"
            data-i18n="reviewsAverageText"
          >
            {{ reviewsAverageText }}
          </h4>
          <span class="mb-2 md:mb-1">
            /5
          </span>
        </div>
        <Stars
          class="mb-4 z-[3]"
          size="xl"
          :score="trip.reviews_average.avg"
        />
        <h5
          class="product-reviews__block_review_counts drop-shadow-light px-6 mb-6 z-[3] font-normal"
          data-i18n="reviewAmountPaxText"
          v-html="formatReviewCount"
        />
      </div>
    </div>
    <div
      v-if="latestreviews?.length"
      class="w-full md:w-7/12 px-3"
    >
      <div class="relative">
        <div
          v-for="(review, index) in latestreviews"
          :key="index"
          class="mb-2"
        >
          <Testimonial
            class="pointer-events-none mb-4 max-md:!rounded-none"
            :rating="review.rating"
            :from="review.from"
            :text="review.text"
            :date="review.date"
            :triangle="isNumberEven(index) ? 'left' : 'right'"
          />
          <template v-if="showTranslationTools">
            <p :data-translation="review?.text_translationkey">
              {{ review.text }}
            </p>
            <p :data-translation="review?.tripname_translationkey">
              {{ review?.tripname }}
            </p>
          </template>
        </div>
        <nuxt-link
          v-if="tripHasReviews"
          class="normal-case text-blue-800 text-lg hover:text-blue-800/75 font-bold right-0 top-full absolute mt-2 underline max-md:mr-2"
          data-i18n="seeAllReviews"
          :to="`${tripPath}${localeURLs.tripSlug.reviews}?top`"
        >
          {{ $t('seeAllReviews') }}
          <fa icon="arrow-right" />
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'

export default defineNuxtComponent({
  setup () {
    const { urls: localeURLs } = useLocale()

    return {
      localeURLs,
    }
  },

  props: {
    trip: {
      type: Object,
      required: true,
    },

    latestreviews: {
      type: Array,
      default: () => ([]),
    },
  },

  computed: {
    ...mapState(useRootStore, ['showTranslationTools']),
    ...mapState(useTripStore, ['tripPath']),

    formatReviewCount () {
      const { count } = this.trip.reviews_average
      return this.$t('reviewAmountPaxText', count).replace(/[0-9]+/, `<strong>${count}</strong>`)
    },

    tripHasReviews () {
      return this.trip?.sections?.reviews_exists
    },

    reviewsAverageText () {
      return formatNumber(this.trip?.reviews_average?.avg)?.slice(0, 3)
    },
  },

  methods: {
    isNumberEven,
    formatNumber,
  },
})
</script>

<style lang="scss">
@import "@layers/web/assets/scss/modules/product/_product-testimonials";
</style>
